import Register from './Components/Authentication/Register';
import Login from './Components/Authentication/Login';
import ForgotPassword from './Components/Authentication/ForgotPassword';
import Resetpassword from './Components/Authentication/ResetPassword';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home';
import ScrollToTop from './ScrollToTop';
import Store from './ReduxStore/Store';
import { Provider } from 'react-redux';
import { useSelector } from 'react-redux';
import NavBar from './NavBar';
import Instructor from './Components/AddCourse/Instructor';
import AddCourse from './Components/AddCourse/AddCourse';
import QuizCreation from './Components/AddCourse/QuizCreation';
import PageNotFound from './Components/PageNotFound/PageNotFound';
import Profile from './Components/Profile/AccountPage';
import DemoCourse from './Components/AddCourseDemo/DemoCourse';
import Footer from './Components/Footer/Footer';
import CourseUploadGuidelines from './Components/Instructions/CourseUploadGuidelines';
import EmailUpdateVerification from './Components/Authentication/EmailUpdateVerfication';
import TermsAndConditions from './Components/TermsAndConditions/TermsAndConditions';
import PrivacyPolicy from './Components/TermsAndConditions/PrivacyPolicy';
import UseTokenValidator from './UseTokenValidator';
import { GoogleOAuthProvider } from '@react-oauth/google';
import ContactFormWithMap from './Components/Support/SiteMap';
 import ContactForm from './Components/Footer/ContactForm';
import AboutUs from './Components/TermsAndConditions/AboutUs';
 
function App() {
  return (
    <Provider store={Store}>
      <GoogleOAuthProvider clientId={`${process.env.REACT_APP_GOOGLE_CLIENT_ID}`}>
      <Main />
      </GoogleOAuthProvider>
    </Provider>
  );
}

function Main() {
  const theme = useSelector(store => store.ThemeSlice.theme);

  const userId = localStorage.getItem('userId');

  const handleLogout = () => {
    localStorage.removeItem('userId');
    localStorage.removeItem('token');
    localStorage.removeItem('fullName');
    localStorage.removeItem('email');
  }
  return (
    <div className={theme}>
      <Router>
        <NavBar user={userId} onLogout={handleLogout} />
        <UseTokenValidator/>
        <ScrollToTop />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/register' element={<Register />} />
          <Route path='/login' element={<Login />} />
          <Route path='/forgot-password' element={<ForgotPassword />} />
          <Route path='/resetpassword' element={<Resetpassword />} />
          <Route path='/verify-email' element={<EmailUpdateVerification />} />
          <Route path='/instructor' element={<Instructor />} />
          <Route path='/add-course' element={<AddCourse />} />
          <Route path="/quiz-creation/:id" element={<QuizCreation />} />
          <Route path='/upload-demo' element={<DemoCourse />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/terms-conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/course-upload-guidelines" element={<CourseUploadGuidelines />} />
          <Route path='/support' element={<ContactForm />} />
          <Route path='/sitemap' element={<ContactFormWithMap />} />
          <Route path='/about' element={<AboutUs />} />
          <Route path='*' element={<PageNotFound />} />        
          </Routes>
          <Footer />
      </Router>
    </div>
  );
}

export default App;
